{
  "version": 1,
  "asset_id": "1276c741-c09b-4cfb-b81f-c9d17ca339d2",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/1276c741-c09b-4cfb-b81f-c9d17ca339d2/wheels-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/1276c741-c09b-4cfb-b81f-c9d17ca339d2/wheels-hero.webp",
  "original_filename": "wheels-hero.webp",
  "size": 68088,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:15Z"
}
